import React from 'react';
import { Star, Quote } from 'lucide-react';
import './ReviewsSection.css';

const ReviewsSection = ({ reviews }) => {
  return (
    <section className="reviews-section" id="reseñas">
      <div className="reviews-container">
        <div className="reviews-header">
          <h2 className="reviews-title">Lo Que Dicen Nuestras Familias</h2>
          <p className="reviews-subtitle">
            Testimonios reales de familias que confían en nosotros
          </p>
        </div>

        <div className="reviews-grid">
          {reviews.map((review) => (
            <div key={review.id} className="review-card">
              <div className="review-quote-icon">
                <Quote size={32} />
              </div>

              <div className="review-stars">
                {[...Array(Number(review.rating))].map((_, index) => (
                  <Star
                    key={index}
                    size={20}
                    fill="#FFD700"
                    color="#FFD700"
                  />
                ))}
              </div>

              <p className="review-comment">"{review.comment}"</p>

              <div className="review-author">
                <div className="review-author-avatar">
                  {review.name.charAt(0)}
                </div>
                <div className="review-author-info">
                  <p className="review-author-name">{review.name}</p>
                  <p className="review-date">{review.date}</p>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="reviews-footer">
          <p className="reviews-footer-text">
            ⭐ Reseñas verificadas de Google Maps
          </p>
        </div>
      </div>
    </section>
  );
};

export default ReviewsSection;
